import styled from "styled-components";
import BackGround from "../../assets/img/background.png";
import BackGroundSmall from "../../assets/img/bg.png";
import BackGroundSubCard from "../../assets/img/img-cardPos.png";
import { green } from "ansi-colors";

export const Section = styled.section`
  background-image: url(${BackGround});
  background-repeat: no-repeat;
  padding-top: 7em;
  padding-bottom: 7em;
  background-size: cover;
  display: flex;
  flex-flow: column;
  justify-content: center;
  .container {
    align-items: center;
    display: flex;
    flex-flow: column;
  }
  @media screen and (max-width: 414px) {
    background-image: url(${BackGroundSmall});
  }
`;

export const Container = styled.div`
  flex-grow: 1;
  margin: 0 auto;
  position: relative;
  width: auto;
  @media screen and (min-width: 1024px) {
    max-width: 960px;
  }
  @media screen and (min-width: 1216px) {
    max-width: 1152px;
  }
  @media screen and (min-width: 1408px) {
    max-width: 1344px;
  }
`;

export const H1 = styled.h1`
  color: white;
  font-size: 2.5em;
  font-weight: 600;
  line-height: 1.125;
  text-align: center;
`;

export const H3 = styled.h2`
  color: white;
  font-size: 1em;
  font-weight: 600;
  text-align: center;
  margin-bottom: 7em;
`;

export const CardList = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

export const SubEventsBox = styled.div`
  position: relative;
  background-color: #1b3647;
  text-align: center;
  padding: 3rem;
`;

export const RowCityInfo = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  margin-bottom: 2rem;
`;

export const CityBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
`;

export const RowCity = styled.div`
  content: "";
  display: none;
  border-top: 2px solid #ceff00;
  height: 1px;
  width: 100%;
  top: 50%;
  z-index: 1;
  @media screen and (min-width: 576px) {
    display: block;
  }
`;

export const CityName = styled.h1`
  color: #ceff00;
  font-size: 8.5vw;
  font-weight: 700;
  @media screen and (min-width: 576px) {
    margin-left: 10px;
    margin-right: 10px;
    font-size: 2em;
    min-width: 250px;
  }

`;

export const Date = styled.span`
  color: #fff;
  font-weight: 600;
`;

export const CardSubEvents = styled.div`
  width: 305px;
  height: 162px;
  margin-top: 1rem;
  margin-bottom: 1rem;
  padding: 1em;
  border-radius: 10px;
  background-size: cover;
  background-color: ${props => (props.showOptions ? "#ceff00" : "")};
  background-image: ${props =>
    props.showOptions ? "#ceff00" : `url(${BackGroundSubCard})`};
  background-repeat: no-repeat;
  display: flex;
  flex-flow: column;
  :hover {
    cursor: pointer;
  }
  justify-content: ${props => (props.showOptions ? "space-around" : "")};
  @media screen and (min-width: 576px) {
    margin: 3rem;
  }
`;

export const AgePlayers = styled.span`
  font-weight: 600;
  margin-bottom: 1.5rem;
  font-size: 7vw;
  color: #ceff00;
  margin-left: 0.5em;
  @media screen and (min-width: 576px) {
    font-size: 2.5rem;
  }
`;

export const AgeInfoPlayers = styled.span`
  font-weight: 600;
  line-height: 1.125;
  font-size: 1.25em;
  color: #ceff00;
  margin-left: 0.5em;
`;

export const RowsAgesInfo = styled.div`
  display: flex;
  align-items: baseline;
`;

export const InfosSubCard = styled.span`
  color: #fff;
  font-size: 1em;
  font-weight: 400;
  text-align: left;
  display: flex;
  align-items: center;
  svg {
    margin-right: 7px;
  }
`;

export const ButtonAction = styled.button`
  width: 249px;
  height: 35px;
  font-weight: 700;
  font-size: 1.25rem;
  border-radius: 10px;
  color: #33393d;
  border: solid 1px #33393d;
  background-color: transparent;
  margin-bottom: ${props => (props.margin ? "1em" : "0em")};
  :hover {
    background-color: #aad401;
  }
`;

export const WaitEvent = styled.div`
  color :#2e3739
  font-size: 24px;
  width: 100%;
  heigth: 200px;
  font-weight: bold;
  background-color:
`;
